/****************************************************************************************************
 * SECTION BLOCKS
 * --------------------------------------------------------------------------------------------------
 * The section blocks component is responsible for rendering the blocks of the section. It handles
 * - the layout of the blocks
 * - the rendering of the blocks
 ****************************************************************************************************/
import React from 'react';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import SectionBlock from './SectionBlock';
import { SanitySectionBlock } from 'src/types/sanity';

interface SectionBlocksProps {
  blocks: SanitySectionBlock[] | null;
}

const SectionBlocks = ({ blocks }: SectionBlocksProps) => {
  // Bail if no blocks, or the block array is empty
  if (!blocks || !blocks.length) return null;

  // Grid Columns
  const gridColumns = 24;

  return (
    <>
      {/********************************************************************************
       * * 24 COLUMN GRID CONTAINER
       * ------------------------------------------------------------------------------
       * The grid container is set to 24 columns. The normal default is 12 but at 24
       * we have more flexibility in the layout of the blocks. This is a good thing. It
       * also removes the need to add an option to the CMS to allow the user to select
       * the number of columns. Again, this is a good thing.
       * ******************************************************************************/}
      <Grid
        // Set to container to 24 columns
        container
        spacing={4}
        columns={gridColumns}        
      >
        {blocks.map((block, index) => {
          /********************************************************************************
           * * DEFAULT GRID COLUMN CONFIGURATION
           * ------------------------------------------------------------------------------
           * Establish the number of columns that the block will span. for each breakpoint.
           * If no value is provided, or if th value is missing then each breakpoint will
           * default to it's own unique default value.
           * ******************************************************************************/
          const gridConfig = {
            xs: block.gridColumns?.xs ?? 24, // xs defaults to 24 columns
            sm: block.gridColumns?.sm ?? 24, // sm defaults to 24 columns
            md: block.gridColumns?.md ?? 12, // md defaults to 12 columns
            lg: block.gridColumns?.lg ?? 12, // lg defaults to 12 columns
            xl: block.gridColumns?.xl ?? 12, // xl defaults to 12 columns
          };

          // const order = index === 2 ? -1 : 'auto';

          let order = block.order ?? [];
        
          return (
            <Grid 
            key={index} 
            {...gridConfig}
            position={'relative'}
            sx={{
              order: order
            }}          
            >              
                <SectionBlock block={block ?? null} />              
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default SectionBlocks;
